import apiClient from './apiClient';

const NotificationService = {
  getNotifications: (params) => apiClient.get('/notifications', { params }),
  getUnreadCount: () => apiClient.get('/notifications/unread/count'),
  markAsRead: (id) => apiClient.patch(`/notifications/${id}/read`),
  markAllAsRead: () => apiClient.patch('/notifications/read-all'),
  archiveNotification: (id) => apiClient.patch(`/notifications/${id}/archive`),
  unarchiveNotification: (id) => apiClient.patch(`/notifications/${id}/unarchive`),
  deleteNotification: (id) => apiClient.delete(`/notifications/${id}`),
  clearAll: () => apiClient.delete('/notifications/clear-all'),
};

export default NotificationService;
